import MaterialsApiService from "./api/MaterialsApiService";

export const getGrades = async (payload, userToken) => {
    try {
        let url = `/disciplines/${payload.disciplineId}/grades?`;

        payload?.materialItemId && (url += `material_item_id=${payload.materialItemId}&`);
        payload?.search && (url += `search=${payload.search}&`);
        payload?.limit && (url += `limit=${payload.limit}&`);
        payload?.status && payload.status != '' && (url += `status=${payload.status}&`);
        payload?.include && (url += `include=${payload.include}&`);

        const response = await MaterialsApiService.get(url.slice(0, -1), {
            headers: {
                'Authorization': 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao consultar notas', error);

        throw error;
    }
}

export const updateGrade = async (payload, userToken) => {
    try {
        const response = await MaterialsApiService.put(`/grades/${payload.gradeId}`, payload, {
            headers: {
                'Authorization': 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao atualizar nota', error);

        throw error;
    }
}

export const exportGradesToCsv = async (payload, userToken) => {
    try {
        let url = `/disciplines/${payload.disciplineId}/grades/csv?`;

        if (payload.materialItemId) {
            url += 'material_item_id=' + payload.materialItemId + '&';
        }

        if (payload.search) {
            url += 'search=' + payload.search + '&';
        }

        if (payload.limit) {
            url += 'limit=' + payload.limit + '&';
        }

        if (payload.status && payload.status != '') {
            url += 'status=' + payload.status + '&';
        }

        const response = await MaterialsApiService.get(url.slice(0, -1), {
            headers: {
                'Authorization': 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao exportar notas', error);

        throw error;
    }
}

export default {
    getGrades,
    updateGrade,
    exportGradesToCsv
}
